import {
  formApiModalPatientHealthDetailsForDoctor,
  formApiModalPatientPreviousVisitDetailForDoctor,
} from "../../../domains/visits/patient-health";
import FetchData from "../../../client";
import { getBranchId, getHospitalId, getPatientId } from "../../../../auth";
import formapimodallabs from "../../../domains/myhealthlabs/labs";
import labsReportViewFormatting from "../../../domains/myhealthlabs/labReportViewFormatting";

const GetPatientHealthData = async (inputData) => {
  try {
    //inputData.doctorid = getLoginID();
    // inputData.patientid = getPatientId();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData(
      "midoc_getpatienthealthdetailfordoctor",
      inputData
    );
    // console.log(inputData);
    // console.log(result, "db response");

    let finalOutput = null;
    if (result.output.data) {
      finalOutput = formApiModalPatientHealthDetailsForDoctor(
        result.output.data
      );
    }
    return finalOutput;
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};


const GetPatientTabularLabData = async (inputData) => {
  try {
    inputData.activeuserid = null;
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData(
      "midoc_getpatienthealthreport",
      inputData
    );
    // console.log(inputData);
    // console.log(result, "db response");

    return result.output.data;
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};

const GetPatientSelectedVisitData = async (inputData, visitDate) => {
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData(
      "midoc_getpatienthealthdetailfordoctor",
      inputData
    );
    // console.log("api", result);

    if (result.output.data) {
      let appointmentDetail = formApiModalPatientHealthDetailsForDoctor(
        result.output.data
      );
      return appointmentDetail;
    }
  } catch (error) {
    console.error("Error fetching data in visits.js:", error);
    throw error;
  }
};

export async function saveAppointmentNotification(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_doctorappointmentnotificationreminder", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in GetAppointmentsList:', error);
    throw error;
  }
}

const UpdateAppointmentStatus = async (inputData) => {
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData("midoc_updateappointmenttime", inputData);
    // console.log("api", result);

    return result;
  } catch (error) {
    console.error("Error fetching data in visits.js:", error);
    throw error;
  }
};

const GetLabTestName = async (inputData) => {
  try {
    
    // inputData.patientid = getLoginInfo();
    // inputData.activeuserid = getUserID();
        const result = await FetchData("midoc_getlabtestname", inputData);
     //console.log(result,"MyHealth db response")
    //  if (result.output.data) {
    //    //console.log(result.output.data)
    //  var finalOutput = formapimodallabs(result.output.data)
    //  }
     //console.log(result, "delete result")
    // console.log(finalOutput, "Labs Formatted output")
    
    return result;

  } catch (error) {
    console.error('Error to delete lab report :', error);
    throw error;
  }
};

const GetTestResultByLabTestId = async (inputData) => {
  try {
    
    // inputData.patientid = getLoginInfo();
    // inputData.activeuserid = getUserID();
        const result = await FetchData("midoc_gettestresultbylabtestid", inputData);
     //console.log(result,"MyHealth db response")
    //  if (result.output.data) {
    //    //console.log(result.output.data)
    //  var finalOutput = formapimodallabs(result.output.data)
    //  }
     //console.log(result, "delete result")
    // console.log(finalOutput, "Labs Formatted output")
    
    return result;

  } catch (error) {
    console.error('Error to delete lab report :', error);
    throw error;
  }
};

const FetchLabsData = async (inputData) => {
  try {
    // inputData.patientid = getLoginInfo();
    // inputData.activeuserid = getUserID();
    const result = await FetchData("midoc_getpatienthealthreport", inputData);
     console.log(result,"labs db response")
     if (result.output.data) {
       //console.log(result.output.data)
     var finalOutput = formapimodallabs(result.output.data)
     }
    // console.log(result, "Labs Result")
    // console.log(finalOutput, "Labs Formatted output")
    
    return finalOutput;

  } catch (error) {
    console.error('Error fetching data in forms.js:', error);
    throw error;
  }
};

const FetchLabsDataForReportsView = async (inputData) => {
  try {
    
    // inputData.patientid = getLoginInfo();
    // inputData.activeuserid = getUserID();
        const result = await FetchData("midoc_getpatienthealthreport", inputData);
     //console.log(result," labs report view original data")
     if (result.output.data) {
       //console.log(result.output.data)
       
     var formattingForReportView = labsReportViewFormatting(result.output.data)
     }
    // console.log(result, "Labs Result")
     //console.log(formattingForReportView, "Labs Formatted data for reports view")
    
    return formattingForReportView;

  } catch (error) {
    console.error('Error fetching data in forms.js:', error);
    throw error;
  }
};

const DeletePatientLabReport = async (inputData) => {
  try {
    
    // inputData.patientid = getLoginInfo();
    // inputData.activeuserid = getUserID();
        const result = await FetchData("midoc_deletepatientreport", inputData);
     //console.log(result,"MyHealth db response")
    //  if (result.output.data) {
    //    //console.log(result.output.data)
    //  var finalOutput = formapimodallabs(result.output.data)
    //  }
     //console.log(result, "delete result")
    // console.log(finalOutput, "Labs Formatted output")
    
    return result;

  } catch (error) {
    console.error('Error to delete lab report :', error);
    throw error;
  }
};

const AddMedicalRecord = async (inputData) => {
  try {
    
    const result = await FetchData("midoc_addmedicalrecord", inputData);
    return result;

  } catch (error) {
    console.error('Error fetching medical conditions data:', error);
    throw error;
  }
};

export {
  GetPatientHealthData,
  GetPatientSelectedVisitData,
  UpdateAppointmentStatus,
  GetPatientTabularLabData,
  GetLabTestName,
  GetTestResultByLabTestId,
  FetchLabsData,
  FetchLabsDataForReportsView,
  DeletePatientLabReport,
  AddMedicalRecord
};
